import styled, { css } from 'styled-components';
import { isPreRelease } from '@finect/front-utils/isPreRelease';
var ICON_SIZES = {
  small: '50%',
  medium: '75%',
  large: '100%'
};
var shadowStyles = css(["box-shadow:0 1px 3px 0 rgb(46 46 51 / 0.25);&:hover{box-shadow:2px 1px 8px 0 rgb(46 46 51 / 0.25);}"]);
export var Placeholder = styled.div.withConfig({
  displayName: "Placeholder",
  componentId: "sc-16251m1-0"
})(["display:block;position:relative;width:100%;padding-top:56.25%;border-radius:", ";cursor:pointer;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var withShadow = _ref2.withShadow;
  return withShadow ? shadowStyles : '';
});
export var PlaceholderOverlay = styled.div.withConfig({
  displayName: "Placeholder__PlaceholderOverlay",
  componentId: "sc-16251m1-1"
})(["display:flex;position:absolute;top:35%;top:calc(50% - 28px);left:calc(50% - 28px);align-items:center;justify-content:center;width:56px;height:56px;svg{opacity:0.95;width:", ";height:", ";cursor:pointer;transition:opacity 150ms;}"], function (_ref3) {
  var iconSize = _ref3.iconSize;
  return ICON_SIZES[iconSize];
}, function (_ref4) {
  var iconSize = _ref4.iconSize;
  return ICON_SIZES[iconSize];
});
export var AspectRatioContent = styled.div.withConfig({
  displayName: "Placeholder__AspectRatioContent",
  componentId: "sc-16251m1-2"
})(["position:absolute;top:0;bottom:0;left:0;right:0;font-size:20px;color:#fff;text-align:center;img{width:100%;height:100%;border-radius:", ";}", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius;
}, function (_ref6) {
  var withNew = _ref6.withNew,
    theme = _ref6.theme;
  return withNew && isPreRelease && "img {border: 3px solid ".concat(theme.colors.secondary, "; border-radius: 4px;}");
});